import React, { useState ,useEffect } from "react";
import { FaUser,FaPhone, FaEnvelope,FaShieldAlt, FaCheckCircle, FaUserCheck, FaUserTimes, FaBuilding, FaMapMarkerAlt,  FaFileInvoice, FaImage,  FaIdCard, FaFilePdf,FaSearch,FaPlus,FaTimes
} from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";
import { FaHouse } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { MdAccountBalance } from "react-icons/md";
import { MdOutlineAccountCircle } from "react-icons/md";
import { BsBank } from "react-icons/bs";

import axios from 'axios'
import toast from "react-hot-toast";

function WebEnquiry({token}) {
const[fetchWeb,setFetchWeb] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
    const [showForm, setShowForm] = useState(false);

  const fetchWebEnquiry = async () => {
  try {
    const res = await axios.get("https://api.krimotion.in/fetch-web-enquiry",
       {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    )
    const result = res.data;
 
    setFetchWeb(result);
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    fetchWebEnquiry();

  }, []);


    const filteredData = Array.isArray(fetchWeb)
    ? fetchWeb.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];

 const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for midnight
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};   

  return (
   <div className="container py-4">

    
        <div className="border-0  mb-3 px-2 py-2  ">
        
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div className="d-flex align-items-center">
              <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
             Web  Enquiry
              </h4>
            </div>
        
            {/* CENTER SEARCH */}
        <div style={{ flex: 1, maxWidth: "250px" }}>
          <div
            className="d-flex align-items-center rounded-pill overflow-hidden"
            style={{
              border: "1px solid var(--green)",
              height: "34px",
              paddingLeft: "8px",
              paddingRight: "8px",
              backgroundColor:'white'
            }}
          >
            {/* ICON */}
            <FaSearch
              style={{
                color: "var(--green)",
                fontSize: "14px",
                display: "flex",
                alignItems: "center"
              }}
            />
        
            {/* INPUT */}
            <input
              type="text"
              className="form-control border-0 shadow-none"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                fontSize: "14px",
                height: "32px",
                marginLeft: "6px",
                lineHeight: "32px"
              }}
            />
          </div>
        </div>
        
         
        
          </div>
        </div>

            {/* {!showForm && (
                     <>
                     
                   
            
                 <div className="card shadow-lg border-0 rounded-4 mt-4 overflow-hidden " style={{ background: '#f4f6f9'}}>
             
                   <div className="card-body p-3">
                            <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0 text-center" >
                    <thead  >
                      <tr>
                      
                        <th className=" text-white" style={{backgroundColor:'var(--green)'}}> Name</th>
                      
                        <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Email</th>
                   
                       
                        <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Description</th>
                        <th className=" text-center text-white" style={{backgroundColor:'var(--green)'}}>Added On</th>
                      </tr>
                    </thead>
            
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((dealer, index) => (
                          <tr key={index}>
                            <td>{dealer.name}</td>
                            <td>{dealer.email}</td>
                            <td>{dealer.description}</td>
                             <td>{formatDate(dealer.added_on)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center py-4">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
        
                  </table>
                </div>
                   </div> 
  
              </div>
            
                </>
                     )} */}


                     {!showForm && (
  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((dealer, index) => (
          <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

            <div className="inventory-card d-flex flex-column h-100">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-start">

                <div>
                  <h5 className="fw-bold mb-1">
                    {dealer.name}
                  </h5>

                  <small className="text-muted">
                    {formatDate(dealer.added_on)}
                  </small>
                </div>

                

              </div>

              <hr />

              {/* Email */}
              <div className="mb-3">

                <div className="fw-semibold text-primary mb-1">
              
                  Email
                </div>

                <div className="support-box">
                  {dealer.email}
                </div>

              </div>

              {/* Message */}
              <div className="mb-3 flex-grow-1">

                <div className="fw-semibold text-success mb-2">
              
                  Message
                </div>

                <div className="support-box">
                  {dealer.description}
                </div>

              </div>

            </div>

          </div>
        ))
      ) : (
        <div className="col-12">
          <div className="text-center py-5">
            No Contact Requests Found
          </div>
        </div>
      )}

    </div>
  </div>
)}
   </div>
  )
}

export default WebEnquiry
